import { useCallback } from 'react';
import { Tabs } from 'antd';
import type { TabsProps } from 'antd';
import { useTranslation } from 'react-i18next';

import { AlertsSettingsNavTabsKeys } from './AlertsSettingsNavTabs.constants';
import styles from './AlertsSettingsNavTabs.module.sass';

interface AlertsSettingsNavTabsProps {
  tab: AlertsSettingsNavTabsKeys;
  onChange: (key: AlertsSettingsNavTabsKeys) => void;
}

const AlertsSettingsNavTabs = ({
  tab,
  onChange,
}: AlertsSettingsNavTabsProps) => {
  const { t } = useTranslation();

  const tabs: TabsProps['items'] = [
    {
      key: 'transaction-alerts',
      label: (
        <span className={styles.tab}>
          {t('translation.transaction_alerts')}
        </span>
      ),
    },
    {
      key: 'behavioral-alerts',
      label: (
        <span className={styles.tab}>
          {t('translation.behavioral_alerts_rules')}
        </span>
      ),
    },
  ];

  const handleTabChange = useCallback(
    (key: string) => {
      onChange(key as AlertsSettingsNavTabsKeys);
    },
    [onChange],
  );

  return (
    <Tabs
      defaultActiveKey={tab}
      size="large"
      items={tabs}
      tabBarGutter={0}
      animated={false}
      className={styles.tabs}
      onChange={handleTabChange}
    />
  );
};

export default AlertsSettingsNavTabs;
